import type React from 'react';

import type { IconComponent } from 'types/icon';
import type { ValueOf } from 'types/utility';

// Response

export type INoticesResponse = INoticeResponse[];

export interface INoticeResponse {
  id: number,
  title: string,
  body: string,
  icon?: string,
  page: NoticePageType,
  slot: NoticeSlotType,
  theme: {
    dark: INoticeResponseTheme,
    light: INoticeResponseTheme
  },
  action: {
    type: typeof NOTICE_ACTIONS_TYPES.LINK,
    url: string
  } | {
    type: typeof NOTICE_ACTIONS_TYPES.MODAL,
    name: NoticeActionModalName
  }
}

export const NOTICE_ACTIONS_TYPES = {
  LINK: 'link',
  MODAL: 'modal'
} as const;

export type NoticeActionType = ValueOf<typeof NOTICE_ACTIONS_TYPES>;

export const NOTICE_ACTION_MODAL_NAMES = {
  PHONE_VALIDATION: 'phone_validation'
} as const;

export type NoticeActionModalName = ValueOf<typeof NOTICE_ACTION_MODAL_NAMES>;

export interface INoticeResponseTheme {
  backgroundColor: string,
  titleTextColor?: string,
  bodyTextColor?: string,
  textColor?: string,
  icon?: string
}

// Models

export type INotices = INotice[];

export interface INotice {
  meta?: {
    id: number,
    page: NoticePageType,
    slot: NoticeSlotType
  },
  details: INoticeDetails,
  action?: INoticeAction
}

export interface INoticeDetails {
  title?: string,
  description?: string,
  icon?: IconComponent | string | React.ReactNode,
  //
  type?: string,
  theme?: INoticeTheme
}

export interface INoticeTheme {
  titleTextColor?: string,
  bodyTextColor?: string,
  backgroundColor: string,
  iconBackgroundColor?: string,
  textColor?: string
}

export type INoticeAction = {
  type: NoticeActionType,
  url?: string,
  name?: NoticeActionModalName
}

// Enums

export const NOTICE_PAGES = {
  CHECKOUT: 'checkout',
} as const;

export type NoticePageType = ValueOf<typeof NOTICE_PAGES>;

export const NOTICE_SLOTS = {
  HEADER: 'header',
  PRODUCTS: 'products',
  FOOTER: 'footer'
} as const;

export type NoticeSlotType = ValueOf<typeof NOTICE_SLOTS>;
